<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import EntityLayout from '@/modules/investing/components/entities/entity-layout.vue'
import { useEntityStore } from '@/modules/investing/stores/better-entity-store'
import DocumentsList from '../components/documents-list.vue'
import { useInvestorStore } from '@/modules/entity/stores/investor-store'
import { createOptions } from '@/modules/shared/utils/form'

const route = useRoute()

const skeleton = ref(true)
const entityStore = useEntityStore()
const investorStore = useInvestorStore()
const investorOptions = computed(() => createOptions(investorStore.state.profiles, { label: 'name' }))

onMounted(async () => {
  await entityStore.fetchEntity(route.params.entity_id as string, { slug: route.params.slug as string })
  skeleton.value = false
})
</script>

<template>
  <EntityLayout selectedTab="esignatures" :skeleton="skeleton">
    <DocumentsList
      :investor_type="route.params.entity_type"
      :investor_id="route.params.entity_id"
      :filterOptions="investorOptions"
      :selected_keys="investorStore.state.selectedKeys"
    />
  </EntityLayout>
</template>
